<div class="border-b border-zinc-300">
  <kendo-panelbar
    [ngClass]="menuConfig.isActivated ? 'kendo-custom-panel-active' : 'kendo-custom-panel'"
    [animate]="false">
    <kendo-panelbar-item [expanded]="menuConfig.isExpanded">
      <ng-template kendoPanelBarItemTitle>
        {{ menuProps()?.title }}
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="flex flex-col gap-4 p-4">
          @if (menuProps()?.items) {
            @for (item of menuProps()?.items; track item.url) {
              @if (item.isEnable) {
                <div
                  [ngClass]="
                    'flex w-full cursor-pointer items-center gap-x-4 rounded p-1 text-black hover:bg-[#E5E7EB] ' +
                    item.cssClass
                  "
                  [routerLink]="[menuProps()?.url, item.url]"
                  routerLinkActive="active bg-gray-200"
                  (click)="closeDrawer()"
                  routerLinkActive="active bg-gray-200">
                  <span class="ml-px"><cs-icon [name]="item.icon" size="large"></cs-icon></span>
                  <span class="overflow-hidden text-base">{{ item.text }}</span>
                </div>
              }
            }
          }
        </div>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
